<template>
  <div class="content-center none-click">
    <div class="banner">
      <img src="@/assets/Mobile/images/solution/b2b-banner.png" alt="">
    </div>
    <div class="block01">
      <div class="page-mobile-title">
        <div class="title">多种业务模式支持，自营&招商模式</div>
        <div class="sub-title">系统完美支持平台自营、商家联营与招商等多种模式,适配多行业转型<br>B2B2C的企业。实现分散经营，集中管理，有利于快速拓展平台规模</div>
      </div>
      <img src="@/assets/Mobile/images/solution/b2b01.png" alt="">
    </div>
    <div class="block02">
      <div class="page-mobile-title">
        <div class="title">店铺独立运营，提供丰富营销活动</div>
        <div class="sub-title">内置丰富营销组件：直播、满减、拼团、砍价与秒杀等。帮助商家高效运营<br>店铺，快速提升销量，轻松解决引流、拓客、转化与复购等营销难题</div>
      </div>
      <img src="@/assets/Mobile/images/solution/b2b02.png" alt="">
    </div>
    <div class="block03">
      <div class="page-mobile-title">
        <div class="title">商城个性化装饰，千店有千面</div>
        <div class="sub-title">商城页面实现可视化装修，UI交互设计，页面随心DIY。系统自带多套模<br>板，满足不同商家的产品和营销风格，为商家打造独特的个性化商城店铺<br>提供了更多选择</div>
      </div>
      <img src="@/assets/Mobile/images/solution/b2b03.png" alt="">
    </div>
    <div class="block04">
      <div class="page-mobile-title">
        <div class="title">会员营销平台，精准营销</div>
        <div class="sub-title">帮助企业搭建会员管理体系，实现会员精细化运营。通过会员权益、会员精<br>准营销提升会员体验，促进消费转化，培育忠诚用户，实现会员全生命周期<br>管理，增强客户粘性带来高复购</div>
      </div>
      <img src="@/assets/Mobile/images/solution/b2b04.png" alt="">
    </div>
    <div class="block05">
      <div class="page-mobile-title">
        <div class="title">分销代理，实现粉丝裂变</div>
        <div class="sub-title">整合内外部流量主，通过提供供应链资源，实现粉丝快速裂变，支持一级、<br>二级分销模式，可自由匹配。完整的分销体系既为店铺带来客户裂变和爆发<br>式的增长，也解决平台拉新拓量与老会员稳定沉淀的问题</div>
      </div>
      <img src="@/assets/Mobile/images/solution/b2b05.png" alt="">
    </div>
    <div class="block06">
      <div class="sk-mobile-title">
        <div class="title">适用客户</div>
      </div>
      <div class="content">
        <div class="item">
          <img src="@/assets/Mobile/images/solution/community08.png" alt="">
          <span>品牌商</span>
        </div>
        <div class="item">
          <img src="@/assets/Mobile/images/solution/b2b06.png" alt="">
          <span>平台商</span>
        </div>
        <div class="item">
          <img src="@/assets/Mobile/images/solution/distribute06.png" alt="">
          <span>大经销商</span>
        </div>
      </div>
    </div>
    <Case title="B2B2C" />
    <ContactForm info-sources="B2B2C" />
  </div>
</template>

<script>
import metaInfo from '@/common/util/metaInfo'
import ContactForm from '@/Mobile/Mobilecom/ContactForm'
import Case from '@/Mobile/Mobilecom/Case'

export default {
  metaInfo: metaInfo.B2B2C,
  components: {
    ContactForm,
    Case
  },
  data() {
    return {

    }
  },
  mounted() {

  },
  methods: {

  }
}
</script>

<style lang="less" scoped>
.banner {
  width: 100%;
  height: 200px;
  margin-top: 50px;
  img {
    width: 100%;
  }
}
.page-mobile-title {
  padding-top: 30px;
  .title {
    font-size: 18px;
    font-weight: 600;
    color: #595961;
    line-height: 25px;
  }
  .sub-title {
    margin-top: 12px;
    font-size: 10px;
    font-weight: 400;
    color: #8B8FA1;
    line-height: 20px;
  }
}
.block01 {
  background-color: #FAFAFA;
  img {
    width: 242px;
    margin: 20px 0;
  }
}
.block02 {
  img {
    width: 265px;
    margin: 20px 0;
  }
}
.block03 {
  background-color: #FAFAFA;
  img {
    width: 258px;
    margin: 22px 0;
  }
}
.block04 {
  img {
    width: 259px;
    margin: 20px 0;
  }
}
.block05 {
  background-color: #FAFAFA;
  img {
    width: 340px;
    margin: 22px 0;
  }
}
.block06 {
  .content {
    padding-top: 20px;
    .item {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      img {
        width: 296px;
      }
      span {
        font-size: 14px;
        font-weight: 500;
        color: #595961;
        line-height: 20px;
        margin: 15px 0 30px 0;
      }
    }
  }
}
</style>
